import React, { useEffect, useState } from 'react'

import CareGiverForm from '../../components/application/careGiver/CareGiverForm'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import { useCareGiverForm } from '../../hooks/useCareGiverForm.ts'

const CareGiver: React.FC = () => {
  const [changeStatus, setChangeStatus] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    changeStatus && setRefreshKey(refreshKey + 1)
    changeStatus && setChangeStatus(false)
  }, [changeStatus])

  const { careGiverData, formik, loading } = useCareGiverForm()

  return (
    <>
      <div className="flex flex-1 flex-row justify-between items-center gap-4 mb-4">
        <div>
          <Breadcrumbs pageName="Dane opiekuna" breadcrumbs={[]} />
        </div>
        <div></div>
      </div>

      <Card>
        <Card.Title>Dane opiekuna wyświetlane w aplikacji</Card.Title>
        <Card.Body>
          {loading && <Loader label={'Pobieranie danych...'} />}
          {!loading && (
            <Card.Body>
              <CareGiverForm formik={formik} careGiverData={careGiverData} />
            </Card.Body>
          )}
        </Card.Body>
      </Card>
    </>
  )
}

export default CareGiver
